// src/components/shared/SearchBar.jsx
import React from 'react';
import FilterSelect from './FilterSelect'; 

const SearchBar = ({ fields }) => {
  return (
    <div className="search-filters">
      {fields.map((field, index) => {
        if (field.type === "text") {
          return (
            <input
              key={index}
              type="text"
              placeholder={field.placeholder}
              value={field.value}
              onChange={(e) => field.onChange(e.target.value)}
              className="search-input"
            />
          );
        } else if (field.type === "select") {
          return (
            <FilterSelect
              key={index}
              value={field.value}
              onChange={field.onChange}
              options={field.options}
              className="filter-select"
            />
          );
        }
        return null;
      })}
    </div>
  );
};

export default SearchBar;